<template>
  <v-card
    class="company-card d-flex flex-column overflow-hidden"
    :loading="loading"
  >
    <v-card-title
      class="company-card-title flex-nowrap"
      :style="{ backgroundColor: siteColors.light }"
      ><span style="font-weight: 400; max-width: 88%" class="text-truncate">{{
        title
      }}</span
      ><v-btn
        v-if="goToSectionButton"
        class="ml-2"
        tag="a"
        :href="sectionLink"
        target="_blank"
        :title="mess.dialog_company_info_go_to_section"
        fab
        color="primary"
        width="24"
        height="24"
        style="min-height: 24px"
        depressed
        ><v-icon small>mdi-arrow-right</v-icon></v-btn
      >
      <div class="ml-auto">
        <toggle-buttons
          v-if="!loading && isToggleButtons"
          :buttons="toggleButtons"
          :active="viewType"
          :small="true"
          :color-inactive="'primary'"
          v-model="viewType"
        ></toggle-buttons></div
    ></v-card-title>

    <slot></slot>

    <v-btn
      v-if="!loading && actionButton"
      color="primary"
      class="align-self-end mr-3 mt-auto"
      depressed
      small
      @click="$emit('action-button-click')"
      >{{ actionButtonTitle }}</v-btn
    >
  </v-card>
</template>

<script>
// Components
import ToggleButtons from "@/components/ToggleButtons";

export default {
  name: "CompanyInfoCard",
  components: { ToggleButtons },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    actionButton: {
      type: Boolean,
      default: false
    },
    actionButtonTitle: {
      type: String,
      default: ""
    },
    goToSectionButton: {
      type: Boolean,
      default: false
    },
    isToggleButtons: {
      type: Boolean,
      default: false
    },
    sectionLink: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    viewTypeProp: {
      type: String,
      default: "total"
    }
  },
  data() {
    return {
      viewType: "total"
    };
  },
  watch: {
    viewTypeProp(val) {
      this.viewType = val;
    },
    viewType(val) {
      this.$emit("input", val);
    }
  },
  computed: {
    toggleButtons() {
      return [
        {
          name: this.mess.dialog_company_info_toggle_button_total,
          type: "total"
        },
        {
          name: this.mess.dialog_company_info_toggle_button_list,
          type: "list"
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.company-card {
  height: 44vh;
  padding-bottom: 10px;

  &::-webkit-scrollbar {
    width: 4px;
    background: rgba(0, 0, 0, 0.12);
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    background: rgba(0, 0, 0, 0.12);
  }
}

.company-card-title {
  line-height: 1;
  letter-spacing: 0;
}
</style>
